import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
// import { useAddQuestionsMutation } from "src/services/QuestionBankServices";
import { JobBoardFormValues } from "src/models/JobBoard.model";
import JobForm from "../Layout/JobForm";
import { useAddJobMutation } from "src/services/JobBoardServices";
type Props = {
  onClose: () => void;
};

const AddJobFormWrapper = ({ onClose }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addJob] = useAddJobMutation();

  // Form Initial Values
  const initialValues: JobBoardFormValues = {
    JobRole: "",
    CompanyName: "",
    JobType: "",
    WorkMode: "",
    requirements: "",
    responsibilities: "",
    jobLocation: "",
    benefitsAndPerks: "",
    aboutComapny: "",
    Experience: "",
    companyLogo: "",
    jobLink : ''
  };

  // Validation Schema
  const validationSchema = object().shape({
    JobRole: string().required("Please enter job role"),
    JobType: object().required("Please select job type"),
    WorkMode: object().required("Please select work mode"),
    CompanyName: string().required("Please enter company name"),
    requirements: string().required("Please enter requirements"),
    responsibilities: string().required("Please enter responsibilities"),
  });

  // Handle Submit
  const handleSubmit = (
    values: JobBoardFormValues,
    { setSubmitting, resetForm }: FormikHelpers<JobBoardFormValues>
  ) => {
    const formatedValue = {
      jobRole: values.JobRole,
      companyName: values.CompanyName,
      jobType: values.JobType?.value,
      workMode: values.WorkMode?.value,
      requirements: values.requirements,
      responsibilities: values.responsibilities,
      jobLocation: values.jobLocation,
      benefitsAndPerks: values.benefitsAndPerks,
      aboutComapny: values.aboutComapny,
      Experience: values.Experience,
      companyLogo: values.companyLogo,
      jobLink: values.jobLink,
    };

    addJob(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          if (!saveNextChecked) {
            resetForm();
            onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="lg" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            <JobForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddJobFormWrapper;
